<template>
  <Drawer
    width="400"
    :title="`${openedMaterial ? '编辑' : '新增'}${convertedType}`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="型号" prop="model">
          <Input v-model="formItem.model" placeholder="输入型号..." />
        </FormItem>
        <FormItem label="材料名" prop="name">
          <Input v-model="formItem.name" placeholder="输入材料名..." />
        </FormItem>
        <FormItem label="用于母液" prop="usedForSemi" v-if="type === 'raw'">
          <i-switch v-model="formItem.usedForSemi" />
        </FormItem>
        <FormItem label="用于复配" prop="usedForProduct" v-if="type === 'raw'">
          <i-switch v-model="formItem.usedForProduct" />
        </FormItem>
        <FormItem label="用于工厂" prop="usedInFactory" v-if="type === 'raw'">
          <Select v-model="formItem.usedInFactory" multiple filterable>
            <Option
              v-for="factory in factoryList"
              :value="factory._id"
              :key="factory._id"
              >{{ factory.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="母液标签选择" prop="tags" v-if="type === 'semi'">
          <CheckboxGroup v-model="formItem.tags">
            <Checkbox label="jianshui">减水</Checkbox>
            <Checkbox label="baotan">保坍</Checkbox>
            <Checkbox label="zaoqiang">早强</Checkbox>
            <Checkbox label="6c">6碳</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem
          label="类型选择"
          prop="series"
          v-if="type === 'product' || type === 'semi'"
        >
          <RadioGroup v-model="formItem.series">
            <Radio label="NAP">
              <span>萘系</span>
            </Radio>
            <Radio label="PCE">
              <span>酸系</span>
            </Radio>
            <Radio label="J">
              <span>减胶剂</span>
            </Radio>
            <Radio label="FSA">
              <span>速凝剂</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EditMaterialDrawer",
  components: {},
  props: {},
  data() {
    return {
      drawerOpened: false,
      type: null,
      openedMaterial: null,
      formItem: {
        name: "",
        model: "",
        usedForSemi: false,
        usedForProduct: false,
        usedInFactory: [],
        series: null,
        tags: [],
      },
      tags: ["jianshui", "baotan", "zaoqiang", "6c"],
      ruleValidate: {
        model: [{ required: true, message: "型号为必填项", trigger: "submit" }],
        name: [{ required: true, message: "名字为必填项", trigger: "submit" }],
        series: [
          { required: true, message: "类型为必填项", trigger: "submit" },
        ],
      },
    };
  },
  computed: {
    convertedType: function () {
      switch (this.type) {
        case "raw":
          return "原材料";
        case "semi":
          return "母液";
        case "product":
          return "产品";
        default:
          return "错误";
      }
    },
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
    }),
  },
  methods: {
    ...mapActions({
      createMaterial: "material/createMaterialAction",
      updateMaterial: "material/updateMaterialAction",
      getFactoryList: "factory/getFactorysAction",
    }),
    openDrawer(type, material) {
      this.$refs["formItem"].resetFields();
      this.getFactoryList({});
      this.type = type;
      this.openedMaterial = material; // 如果有打开的材料，则为编辑模式
      if (material) {
        this.formItem.name = material.name;
        this.formItem.model = material.model;
        this.formItem.usedForSemi = material.usedForSemi || false;
        this.formItem.usedForProduct = material.usedForProduct || false;
        if (material.usedInFactory && material.usedInFactory.length > 1) {
          this.formItem.usedInFactory = material.usedInFactory
            .map((item) => {
              return item._id;
            })
            .join(",")
            .split(",");
        }
        this.formItem.series = material.series;
        this.formItem.tags = material.tags;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedMaterial) {
              await this.updateMaterial({
                id: this.openedMaterial._id,
                data: this.formItem,
              });
            } else {
              await this.createMaterial({ ...this.formItem, type: this.type });
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
